export const usernamePlaceholder = "Username";
export const passwordPlaceholder = "Password";
export const emailPlaceholder = "Email";
export const currentPasswordPlaceholder = "Current Password";
export const newPasswordPlaceholder = "New Password";
export const confirmPasswordPlaceholder = "Confirm Password";
export const batchNumberPlaceholder = "Batch Number";
export const noDataFound = "No pending request for the specific account";
